.container {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
}
